import React, {createContext} from 'react'

const ThingsContext = createContext({})

export const ThingsProvider = ThingsContext.Provider

export default ThingsContext
